import { useEffect, useState } from 'react';
import { Alert, Box, Button, Collapse, Stack, Typography } from '@mui/material';
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';
import api from 'api/client';

export default function MaintenanceBanner() {
  const [state, setState] = useState({ visible: false, message: '' });
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      try {
        const { data } = await api.get('/api/maintenance/status/');
        if (!mounted) return;
        setState({
          visible: Boolean(data?.enabled && data?.banner_enabled),
          message: data?.message || 'Scheduled platform maintenance is in progress.'
        });
      } catch {
        if (mounted) setState({ visible: false, message: '' });
      }
    };

    load();
    const timer = window.setInterval(load, 60000);
    return () => {
      mounted = false;
      window.clearInterval(timer);
    };
  }, []);

  return (
    <Collapse in={state.visible && !dismissed}>
      <Box sx={{ mb: 1.6 }}>
        <Alert
          severity="warning"
          icon={<BuildCircleOutlinedIcon />}
          action={
            <Button color="inherit" size="small" onClick={() => setDismissed(true)}>
              Dismiss
            </Button>
          }
          sx={{
            borderRadius: 2,
            border: '1px solid rgba(245, 158, 11, 0.36)',
            bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'rgba(245, 158, 11, 0.12)' : 'rgba(255, 251, 235, 0.92)'),
            '& .MuiAlert-message': { width: '100%' }
          }}
        >
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={0.8} alignItems={{ xs: 'flex-start', md: 'center' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
              Maintenance Mode
            </Typography>
            <Typography variant="body2">{state.message}</Typography>
          </Stack>
        </Alert>
      </Box>
    </Collapse>
  );
}
